import React, { useState } from 'react';
import ReactSelect, {
  createFilter,
  MultiValue,
  SingleValue,
} from 'react-select';

import { StyledSelect } from './Select.styles';

import { OptionProps, SelectProps } from './Select.types';

//TODO Remove Duplicate "classNamePrefix" prop (duplicate of "componentClassname")
/**
 * Custom select input base on react-select (https://react-select.com/)
 */
const Select = ({
  name,
  options = [],
  defaultValue = null,
  placeholder = '',
  classNamePrefix = 'select',
  isDisabled = false,
  hasError = false,
  inputProps = {},
  onChange,
  beforeSelectSlot,
  afterSelectSlot,
  componentClassname = 'select',
  customClassnames = '',
  customStyle = '',
}: SelectProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <StyledSelect
      className={`${componentClassname}__wrapper${
        isFocused ? ` ${componentClassname}__wrapper--is-focused` : ''
      }${isDisabled ? ` ${componentClassname}__wrapper--is-disabled` : ''}${
        hasError ? ` ${componentClassname}__wrapper--has-error` : ''
      }`}
      customStyle={customStyle}
    >
      {beforeSelectSlot}
      <ReactSelect
        name={name}
        classNamePrefix={classNamePrefix}
        className={`${customClassnames}${
          isFocused && classNamePrefix ? ` ${classNamePrefix}--is-focused` : ''
        }`}
        placeholder={placeholder}
        options={options}
        defaultValue={defaultValue}
        onChange={(
          newValue: SingleValue<OptionProps> | MultiValue<OptionProps> | null,
        ) => onChange(newValue)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        filterOption={createFilter({
          matchFrom: 'any',
          stringify: (option) =>
            option.data?.labelStringified ||
            (typeof option.label === 'string' ? option.label : option.value),
        })}
        isDisabled={isDisabled}
        {...inputProps}
      />
      {afterSelectSlot}
    </StyledSelect>
  );
};
Select.displayName = 'Select';

export default Select;
